/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
/* eslint-disable import/no-unresolved */
import axios from "axios";
import { Dayjs } from "dayjs";
import API_URLS from "src/config/API_URLS";
import axiosInstance from "src/utils/Axios/axiosInstance";

const dashboardLeadCall = async (
  limit: number,
  sortBy: string,
  page: number,
  filterByOptions: Record<string, any>,
  search: string,
  searchOn: string,
  dateFilters: {
    startDate: Dayjs | null;
    endDate: Dayjs | null;
  }
) => {
  try {
    const response = await axiosInstance.get(API_URLS.dashboard, {
      params: {
        sortBy,
        ...filterByOptions,
        ...(search && { search }),
        ...(searchOn && { searchOn }),
        ...(dateFilters.startDate && {
          startDate: dateFilters.startDate.format("YYYY-MM-DD")
        }),
        ...(dateFilters.endDate && { endDate: dateFilters.endDate.format("YYYY-MM-DD") }),
        page,
        limit
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const actionBucketCall = async (leadId: string, bucket: string) => {
  try {
    const response = await axiosInstance.put(`${API_URLS.actionBucket}/${leadId}`, { bucket });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const sendPaymentLinkCall = async (id: string) => {
  try {
    const response = await axiosInstance.post(API_URLS.sendPaymentLink, { id });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const downloadDocument = async (body: Record<string, any>) => {
  try {
    const response: any = await axiosInstance.post(`${API_URLS.downloadDocument}`, body);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const getUserList = async (params: Record<string, any>) => {
  try {
    const response: any = await axiosInstance.get(`${API_URLS.getUserList}`, {
      params
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const caseReassign = async (body: Record<string, any>) => {
  try {
    const response: any = await axiosInstance.post(`${API_URLS.caseReassign}`, body);
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const triggerWorkflow = async (leadId: string) => {
  try {
    const response: any = await axiosInstance.get(`${API_URLS.triggerWorkflow}`, {
      params: {
        leadId
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const uploadPAFFile = async (file: File) => {
  try {
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post(API_URLS.uploadPAF, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
    return response;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

const getBlobDownloadURI = async (decodedURI: string) => {
  try {
    const response = await axios.get(decodedURI, {
      responseType: "blob"
    });
    const blobUrl = window.URL.createObjectURL(response?.data);
    return blobUrl;
  } catch (response: any) {
    throw new Error(response?.data?.error?.message);
  }
};

export {
  dashboardLeadCall,
  actionBucketCall,
  sendPaymentLinkCall,
  downloadDocument,
  getUserList,
  caseReassign,
  triggerWorkflow,
  uploadPAFFile,
  getBlobDownloadURI
};
